export const getDefaultFilter = (type: 'driver' | 'mixer' | 'employee' | 'pump') => {
  if (type === 'driver') {
    return ['postId', '=', 3];
  }

  if (type === 'mixer') {
    return [['postId', '=', 2], 'and', ['status', '=', 0]];
  }

  if (type === 'pump') {
    return ['postId', '=', 1];
  }

  if (type === 'employee') {
    return [['postId', '<>', 2], 'and', ['postId', '<>', 3]];
  }

  return [];
};
